import { createFileRoute } from "@tanstack/react-router";
import VersionPage from "../pages/Version";

export const Route = createFileRoute("/version")({
  component: VersionPage,
});
